
<template>
  <div class="StoreInfo-component">
      <div class="storeInfo">
        <div class="storeMsg">
            <div class="left">
                <img v-lazy="dataSource.store_img" alt="">
            </div>
            <div class="right">
                <div class="title van-ellipsis">{{dataSource.store_name}}</div>
                <div class="text">
                    <div class="certification" v-if="dataSource.certification">资质：<i class="ico ico-icon_95"></i></div>
                    <div class="credit" v-if="dataSource.credit.type">
                        <span>信用：</span>
                        <img :src="dataSource.credit.image" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="intro"><span class="van-multi-ellipsis--l2">{{dataSource.intro}}</span></div>
    </div>
  </div>
</template>

<script >
export default {
    name: 'StoreInfo',
    props: {
        dataSource: {
            type: Object,
            required: true
        }
    },
    data () {
        return {

        }
    },
    created () {

    },
    activated () {

    },
    mounted () {

    },
}
</script>

<style lang="stylus" scoped>
@import "../../assets/stylus/variables";

.StoreInfo-component
    margin 30px
    .storeInfo
        padding 30px 30px 0
        border-radius 16px
        background-color $fcWhite
        .storeMsg
            display flex
            .left
                width 88px
                height 88px
                margin-right 20px
                overflow hidden
                img
                    display block
                    width 100%
                    height 100%
            .right
                width calc(100% - 108px)
                .title
                    font-size $fontBase
                    color $fcGrey
                .text
                    display flex
                    padding-top 16px
                    .certification
                    .credit
                        display flex
                        // align-items flex-end
                        align-items center
                    .certification
                        padding-right 50px
                    .credit
                        flex auto
                        span
                            white-space nowrap
                        img
                            height 26px
                            width auto
                            object-fit: contain;
        .intro
            padding 15px 0 34px
            width 100%
</style>
